import { useFormikContext } from "formik";

import { FormikTextInput } from "@sso/components/Formik";
import FormikSelectWithBlur from "@sso/components/Formik/FormikSelectWtihBlur";
import {
  LicenceType,
  PaymentType,
  SoftwareLicenceFormValues,
  SoftwareLicenceSummaryKeys,
  timeUnitOption,
} from "@sso/types";

const LicenceTypeSpecificFields = () => {
  const { values } = useFormikContext<SoftwareLicenceFormValues>();

  return (
    <>
      {values[SoftwareLicenceSummaryKeys.LICENCE_TYPE] === LicenceType.CONCURRENT && (
        <FormikTextInput type="number" label={"Concurrent Users"} name={"defaultConcurrentUsers"} />
      )}
      {values[SoftwareLicenceSummaryKeys.PAYMENT_TYPE] &&
        values[SoftwareLicenceSummaryKeys.LICENCE_TYPE] &&
        values[SoftwareLicenceSummaryKeys.PAYMENT_TYPE] !== PaymentType.PaymentOnAccount && (
          <>
            <FormikTextInput type="number" label={"Expiry time value"} name={"expiryTimeValue"} />
            <FormikSelectWithBlur name={"expiryTimeUnit"} label="Expiry time unit" items={timeUnitOption} />
          </>
        )}
    </>
  );
};

export default LicenceTypeSpecificFields;
